import { Router } from "@reach/router";
import React, { ReactNode } from "react";
import { CognitoStore, session } from "src/stores/cognito-store";
import PrivateRoute from "src/components/General/PrivateRoute";
import { navigate } from "gatsby";
import Loading from "src/components/General/Loading";
import SEONoIndex from "src/components/General/SEONoIndex";
import { ToastContainer } from "react-toastify";
import { Container } from "reactstrap";
// core components
import { ManageProfilesComponent } from "src/components/My/Profiles/ManageProfiles";
import { ProfileWizard } from "src/components/My/Profiles/ProfileWizard";
import PreviewProfile from "src/components/My/Profiles/Preview";
import { CognitoSession } from "src/models/CognitoSession";
import { StripeVerificationForm } from "src/components/General/StripeVerificationForm";
import { GettingStarted } from "src/components/Users/GettingStarted";

interface MyPageProps {
  location: any;
}
interface MyPageState {
  username: string;
  userGroups: string[];
  firstName: string;
  ready: boolean;
  session: CognitoSession;
}

// eslint-disable-next-line import/no-default-export
export default class MyPage extends React.Component<MyPageProps, MyPageState> {
  private authSub: any;

  constructor(props: MyPageProps) {
    super(props);
    this.state = {
      username: "",
      userGroups: [],
      firstName: "",
      ready: false,
      session: null,
    };
  }

  public componentDidMount(): void {
    CognitoStore.refreshSession()
      .then((s: CognitoSession) => {
        this.setState({
          username: s.username,
          userGroups: s.groups,
          firstName: s.firstName,
          session: s,
        });
        this.authSub = session.subscribe((sess) => {
          if (!sess) {
            // user has signed out
            navigate("/");
          }
        });
        if (s.groups.length === 0) {
          navigate("/my/journey/");
        } else if (s.groups.includes("verification")) {
          navigate("/my/verification/");
        } else if (s.groups.includes("community") || s.groups.includes("provider")) {
          // provider or community user types will manage profiles view by default
          navigate("/my/profiles/");
        } else {
          console.error("no matching user type!");
        }
        this.setState({
          ready: true,
        });
        // eslint-disable-next-line no-useless-return
        return;
      })
      .catch((error: any) => {
        console.error(error);
        navigate("/login/");
      });
  }

  public componentWillUnmount(): void {
    if (this.authSub) {
      this.authSub.unsubscribe();
    }
  }

  // tslint:disable:max-line-length
  public render(): ReactNode {
    let mySection;
    if (!this.state.ready) {
      mySection = (
        <Container>
          <Loading />
        </Container>
      );
    } else {
      mySection = (
        <Router>
          {/*
          user/patient views
          */}
          <PrivateRoute
            path="/my/journey/"
            component={GettingStarted}
            username={this.state.username}
            userGroups={this.state.userGroups}
          />
          {/*
          provider/community views
          */}
          <PrivateRoute
            path="/my/verification/"
            component={StripeVerificationForm}
            firstName={this.state.firstName}
            username={this.state.username}
            userGroups={this.state.userGroups}
          />
          <PrivateRoute path="/my/profiles/" component={ManageProfilesComponent} session={this.state.session} />
          <PrivateRoute path="/my/profiles/:slug/" component={ProfileWizard} username={this.state.username} />
          <PrivateRoute
            path="/my/profiles/new/:newProfileType/"
            component={ProfileWizard}
            username={this.state.username}
          />
          <PrivateRoute path="/my/profiles/:slug/preview/" component={PreviewProfile} username={this.state.username} />
        </Router>
      );
    }
    return (
      <div className="manage">
        <SEONoIndex title="My Psychedelic Support" />
        <ToastContainer hideProgressBar={true} />
        {mySection}
      </div>
    );
  }
}
